import { IMAGES } from "../data/site";
import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Zambian at heart",
    body: "Registered in Zambia (No. 120261053235) and operating from Lusaka, we trade what this land does best — coal, copper and aluminium.",
  },
  {
    n: "02",
    title: "Copper, below LME",
    body: "Our flagship deal: Copperbelt ingots at 10% under LME prices — 100 MT minimum, 30% advance and the balance only when your cargo reaches its destination port. Our coal yards stay stocked too, at prices nobody beats.",
  },
  {
    n: "03",
    title: "Trust in trade",
    body: "Inspections by SGS on request, full export documentation, and founders who answer their own phones. We build repeat buyers, not one-off deals.",
  },
  {
    n: "04",
    title: "Worldwide reach",
    body: "From Southern Africa to Asia and beyond — we coordinate freight, paperwork and ports so your cargo arrives as promised.",
  },
];

export const Manifesto = () => (
  <section id="about" className="relative overflow-hidden border-y border-zinc-800" data-testid="manifesto-section">
    <div className="absolute inset-0 -z-10">
      <img src={IMAGES.coalMine} alt="" className="h-full w-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-black/70" />
    </div>

    <div className="mx-auto max-w-[1400px] px-6 py-28 lg:px-12 lg:py-40">
      <Reveal>
        <p className="font-mono-label text-xs text-copper">02 — The manifesto</p>
        <h2 className="font-display mt-6 max-w-3xl text-4xl font-semibold uppercase leading-tight text-zinc-100 sm:text-5xl lg:text-6xl">
          Built on rock.<br />Driven by <span className="text-copper">fire.</span>
        </h2>
      </Reveal>

      <div className="mt-20 grid grid-cols-1 gap-x-12 gap-y-16 md:grid-cols-2">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.1}>
            <div className="border-t border-zinc-700 pt-8" data-testid={`manifesto-chapter-${c.n}`}>
              <span className="font-mono text-sm text-copper">{c.n}</span>
              <h3 className="font-display mt-4 text-2xl font-semibold uppercase text-zinc-100 lg:text-3xl">{c.title}</h3>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-400 md:text-base">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
